var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiscoLogoLight = function SvgDiscoLogoLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 901 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.743 112.556c6.004 0 10.871-4.867 10.871-10.871 0-6.004-4.867-10.871-10.87-10.871-6.004 0-10.872 4.867-10.872 10.871 0 6.004 4.868 10.871 10.871 10.871Z",
    fill: "url(#disco-logo-light_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.546 80.94c7.096 0 12.848-5.753 12.848-12.848 0-7.096-5.752-12.847-12.848-12.847-7.095 0-12.847 5.752-12.847 12.847s5.752 12.847 12.847 12.847Z",
    fill: "url(#disco-logo-light_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.891 65.89c6.55 0 11.86-5.31 11.86-11.859 0-6.55-5.31-11.859-11.86-11.859s-11.859 5.31-11.859 11.86c0 6.549 5.31 11.858 11.86 11.858Z",
    fill: "url(#disco-logo-light_svg__c)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.152 78.754c6.003 0 10.87-4.867 10.87-10.871 0-6.004-4.867-10.87-10.87-10.87-6.004 0-10.871 4.866-10.871 10.87s4.867 10.87 10.87 10.87Z",
    fill: "url(#disco-logo-light_svg__d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.088 111.422c5.458 0 9.883-4.425 9.883-9.883 0-5.458-4.425-9.882-9.883-9.882-5.458 0-9.882 4.424-9.882 9.882 0 5.458 4.424 9.883 9.882 9.883Z",
    fill: "url(#disco-logo-light_svg__e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.94 145.161c5.458 0 9.883-4.425 9.883-9.883 0-5.458-4.425-9.882-9.883-9.882-5.458 0-9.883 4.424-9.883 9.882 0 5.458 4.425 9.883 9.883 9.883Z",
    fill: "url(#disco-logo-light_svg__f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.599 159.222c5.458 0 9.882-4.425 9.882-9.883 0-5.458-4.424-9.882-9.882-9.882-5.458 0-9.883 4.424-9.883 9.882 0 5.458 4.425 9.883 9.883 9.883Z",
    fill: "url(#disco-logo-light_svg__g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.338 146.358c6.004 0 10.871-4.867 10.871-10.871 0-6.003-4.867-10.871-10.871-10.871-6.003 0-10.87 4.868-10.87 10.871 0 6.004 4.867 10.871 10.87 10.871Z",
    fill: "url(#disco-logo-light_svg__h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.398 113.695c6.55 0 11.86-5.31 11.86-11.859 0-6.55-5.31-11.86-11.86-11.86-6.549 0-11.859 5.31-11.859 11.86 0 6.549 5.31 11.859 11.859 11.859Z",
    fill: "url(#disco-logo-light_svg__i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.637 53.616c8.187 0 14.824-6.636 14.824-14.824 0-8.187-6.637-14.823-14.824-14.823-8.187 0-14.824 6.636-14.824 14.823 0 8.188 6.637 14.824 14.824 14.824Z",
    fill: "url(#disco-logo-light_svg__j)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.44 23.619c5.403-5.403 5.403-14.163 0-19.567-5.404-5.403-14.164-5.403-19.567 0-5.403 5.404-5.403 14.164 0 19.567 5.403 5.403 14.163 5.403 19.567 0Z",
    fill: "url(#disco-logo-light_svg__k)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.75 30.827c4.632-4.632 4.632-12.14 0-16.772-4.63-4.631-12.14-4.631-16.77 0-4.632 4.632-4.632 12.14 0 16.772 4.63 4.63 12.14 4.63 16.77 0Z",
    fill: "url(#disco-logo-light_svg__l)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.485 68.294c3.86-3.86 3.86-10.117 0-13.976-3.86-3.86-10.117-3.86-13.976 0-3.86 3.859-3.86 10.116 0 13.976 3.86 3.859 10.116 3.859 13.976 0Z",
    fill: "url(#disco-logo-light_svg__m)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.184 121.889a8.894 8.894 0 0 0 0-12.578 8.893 8.893 0 0 0-12.579 0 8.894 8.894 0 0 0 0 12.578 8.893 8.893 0 0 0 12.579 0Z",
    fill: "url(#disco-logo-light_svg__n)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.85 172.484a7.906 7.906 0 1 0-.001-15.813 7.906 7.906 0 0 0 0 15.813Z",
    fill: "url(#disco-logo-light_svg__o)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.12 195.823a8.895 8.895 0 1 0-12.58-12.579 8.895 8.895 0 0 0 12.58 12.579Z",
    fill: "url(#disco-logo-light_svg__p)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M144.114 187.923c3.859-3.859 3.859-10.116 0-13.976-3.86-3.859-10.117-3.859-13.977 0-3.859 3.86-3.859 10.117 0 13.976 3.86 3.86 10.117 3.86 13.977 0Z",
    fill: "url(#disco-logo-light_svg__q)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M184.38 150.45c4.631-4.631 4.631-12.14 0-16.771-4.632-4.631-12.14-4.631-16.772 0-4.631 4.631-4.631 12.14 0 16.771 4.632 4.631 12.14 4.631 16.772 0Z",
    fill: "url(#disco-logo-light_svg__r)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.376 97.553c5.403-5.403 5.403-14.163 0-19.566-5.403-5.403-14.164-5.403-19.567 0-5.403 5.403-5.403 14.163 0 19.566 5.403 5.404 14.164 5.404 19.567 0Z",
    fill: "url(#disco-logo-light_svg__s)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M285.362 147.053h23.212c13.083 0 23.844-4.08 32.285-12.239 8.441-8.159 12.661-19.976 12.661-35.45 0-15.475-4.22-27.292-12.661-35.45-8.441-8.3-19.132-12.45-32.074-12.45h-23.423v95.589Zm24.267 27.01h-53.387V24.453h53.598c21.805 0 39.53 6.682 53.176 20.047 13.786 13.364 20.679 31.652 20.679 54.864 0 23.07-6.893 41.288-20.679 54.652-13.787 13.365-31.582 20.047-53.387 20.047ZM438.481 174.063h-29.542V24.453h29.542v149.61ZM569.048 60.115l-26.165 8.018c-.985-5.345-3.658-10.199-8.019-14.56-4.361-4.36-10.762-6.541-19.202-6.541-6.893 0-12.521 1.899-16.882 5.697-4.36 3.658-6.541 8.09-6.541 13.294 0 9.144 5.416 14.771 16.248 16.881l20.891 4.01c13.223 2.532 23.493 7.807 30.808 15.826 7.315 8.018 10.973 17.444 10.973 28.276 0 12.379-4.924 23.211-14.772 32.496-9.706 9.144-22.789 13.716-39.248 13.716-9.426 0-17.936-1.407-25.533-4.22-7.597-2.814-13.716-6.542-18.358-11.184-4.643-4.783-8.3-9.777-10.973-14.982-2.532-5.346-4.08-10.832-4.642-16.459l27.009-7.175c.704 8.019 3.799 14.701 9.285 20.047 5.627 5.345 13.435 8.018 23.423 8.018 7.596 0 13.505-1.688 17.725-5.064 4.361-3.376 6.541-7.808 6.541-13.294 0-4.361-1.617-8.089-4.853-11.184-3.095-3.235-7.526-5.416-13.294-6.541l-20.89-4.221c-12.098-2.532-21.664-7.526-28.698-14.982-7.034-7.456-10.551-16.74-10.551-27.854 0-13.223 5.064-24.337 15.193-33.34 10.269-9.003 22.579-13.505 36.928-13.505 8.581 0 16.248 1.196 23 3.587 6.753 2.392 12.169 5.627 16.248 9.707 4.08 3.939 7.245 8.019 9.496 12.239a50.262 50.262 0 0 1 4.853 13.294ZM663.069 177.228c-21.524 0-39.671-7.175-54.442-21.524s-22.157-33.129-22.157-56.34c0-23.071 7.456-41.852 22.368-56.341 15.052-14.49 32.988-21.735 53.809-21.735 19.132 0 34.465 4.853 46.001 14.56 11.676 9.707 19.202 21.383 22.578 35.029l-27.432 8.651c-2.11-8.44-6.541-15.545-13.293-21.312-6.753-5.909-16.038-8.863-27.854-8.863-12.239 0-23.001 4.361-32.286 13.083-9.144 8.722-13.716 21.031-13.716 36.928 0 15.193 4.502 27.22 13.505 36.083 9.144 8.863 20.117 13.294 32.919 13.294 11.676 0 20.96-3.025 27.854-9.074 7.033-6.049 11.746-13.223 14.138-21.523l27.22 8.229c-1.547 6.05-4.079 11.958-7.596 17.726-3.376 5.767-7.808 11.183-13.294 16.248-5.486 5.064-12.45 9.144-20.89 12.239-8.3 3.095-17.444 4.642-27.432 4.642ZM790.276 62.436c-9.285 8.581-13.927 20.82-13.927 36.717 0 15.896 4.642 28.205 13.927 36.927 9.284 8.581 20.187 12.872 32.707 12.872 12.661 0 23.634-4.291 32.918-12.872 9.285-8.722 13.927-21.031 13.927-36.928 0-15.896-4.642-28.135-13.927-36.716-9.284-8.722-20.257-13.083-32.918-13.083-12.52 0-23.423 4.361-32.707 13.083Zm-44.102 36.928c0-23.353 7.526-42.203 22.578-56.552 15.053-14.35 33.13-21.524 54.231-21.524 21.242 0 39.39 7.175 54.442 21.524s22.578 33.2 22.578 56.552c0 23.211-7.526 41.991-22.578 56.34-15.052 14.349-33.2 21.524-54.442 21.524-21.101 0-39.178-7.175-54.231-21.524-15.052-14.349-22.578-33.129-22.578-56.34Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__a",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__b",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__c",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__d",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__e",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__f",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__g",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__h",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__i",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__j",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__k",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__l",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__m",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__n",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__o",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__p",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__q",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__r",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "disco-logo-light_svg__s",
    x1: 0.006,
    y1: 198.214,
    x2: 218.252,
    y2: 24.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4467F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8AA0F9"
  })))));
};

export default SvgDiscoLogoLight;